import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, AlertTriangleIcon } from 'lucide-react';
export function HiddenCost() {
  return <section className="w-full py-6 md:py-8" data-id="element-112">
      <div className="max-w-xl mx-auto px-4 md:px-6" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative rounded-2xl border-2 border-red-500/60 bg-[#141414] p-5 md:p-6" style={{
        boxShadow: '0 0 24px rgba(239, 68, 68, 0.15), inset 0 0 0 1px rgba(239, 68, 68, 0.08)'
      }} data-id="element-114">
          {/* Alert tag */}
          <div className="flex justify-center mb-3" data-id="element-115">
            <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 rounded-full px-2.5 py-1" data-id="element-116">
              <span className="relative flex h-1.5 w-1.5" data-id="element-117">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-118" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-red-500" data-id="element-119" />
              </span>
              <span className="text-[9px] md:text-[10px] font-bold uppercase tracking-[0.2em] text-red-500" data-id="element-120">
                Alerta · Desgaste semanal
              </span>
            </div>
          </div>

          {/* Title */}
          <h2 className="text-center font-['Open_Sans',_sans-serif] text-lg md:text-2xl font-[900] text-white leading-tight mb-1" data-id="element-121">
            Dejá de pagar con tu{' '}
            <span className="text-red-500" data-id="element-122">tiempo libre.</span>
          </h2>

          {/* Subtitle */}
          <p className="text-center text-gray-400 text-[11px] md:text-xs mb-4" data-id="element-123">
            El costo oculto de improvisar la consulta:
          </p>

          {/* Hero stat */}
          <div className="text-center mb-4" data-id="element-124">
            <div className="flex items-baseline justify-center gap-1.5" data-id="element-125">
              <span className="text-4xl md:text-5xl font-black text-red-500 leading-none" data-id="element-126">
                +100
              </span>
              <span className="text-xl md:text-2xl font-black text-red-500" data-id="element-127">
                hrs
              </span>
            </div>
            <p className="mt-1.5 text-[9px] md:text-[10px] uppercase tracking-[0.2em] text-white font-bold" data-id="element-128">
              Perdidas al año de tu vida personal
            </p>
          </div>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-red-500/25 to-transparent mb-4" data-id="element-129" />

          {/* Stat rows */}
          <div className="space-y-2" data-id="element-130">
            <div className="bg-white/5 border border-red-500/20 rounded-xl p-2.5 md:p-3 flex items-center gap-3" data-id="element-131">
              <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-red-500/10 border border-red-500/25 flex items-center justify-center" data-id="element-132">
                <ClockIcon size={16} className="text-red-500" data-id="element-133" />
              </div>
              <div className="min-w-0" data-id="element-134">
                <p className="text-white font-bold text-xs md:text-sm leading-tight" data-id="element-135">
                  2 a 4 horas por semana
                </p>
                <p className="text-gray-400 text-[11px] leading-snug" data-id="element-136">
                  armando materiales y explicaciones a mano.
                </p>
              </div>
            </div>

            <div className="bg-white/5 border border-red-500/20 rounded-xl p-2.5 md:p-3 flex items-center gap-3" data-id="element-137">
              <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-red-500/10 border border-red-500/25 flex items-center justify-center" data-id="element-138">
                <AlertTriangleIcon size={16} className="text-red-500" data-id="element-139" />
              </div>
              <div className="min-w-0" data-id="element-140">
                <p className="text-white font-bold text-xs md:text-sm leading-tight" data-id="element-141">
                  Fines de semana, noches y familia
                </p>
                <p className="text-gray-400 text-[11px] leading-snug" data-id="element-142">
                  tiempo que ya no vuelve.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}